import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import ReserveTypeEdit      from "./ReserveTypeEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Reserve Type List
 * @returns {React.ReactElement}
 */
function ReserveTypeList() {
    const { fetch, load } = useList("reserveType");

    const data = Store.useState("reserveType");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("reserveType");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "reserveTypeID", elemID, "name");

    return <Main>
        <Header message="RESERVE_TYPES_NAME" icon="reserve-type">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="RESERVE_TYPES_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="name"                 message="GENERAL_NAME"                isTitle bigMobile />
                    <TableHeader field="activityName"         message="ACTIVITIES_SINGULAR"         />
                    <TableHeader field="notificationTypeName" message="NOTIFICATION_TYPES_SINGULAR" />
                    <TableHeader field="visitTypeName"        message="RESERVE_TYPES_VISIT_TYPE"    />
                    <TableHeader field="courtCount"           message="COURTS_NAME"                 maxWidth="100" align="center" />
                    <TableHeader field="periodCount"          message="GENERAL_PERIODS"             maxWidth="80"  align="center" />
                    <TableHeader field="status"               message="GENERAL_STATUS"              maxWidth="100" align="center" />
                    <TableHeader field="position"             message="GENERAL_POSITION"            maxWidth="80"  align="center" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.reserveTypeID} elemID={elem.reserveTypeID}>
                        <TableCell message={elem.name}                 />
                        <TableCell message={elem.activityName}         />
                        <TableCell message={elem.notificationTypeName} />
                        <TableCell message={elem.visitTypeName}        />
                        <TableCell message={elem.courtCountText}       />
                        <TableCell message={elem.periodCountText}      />
                        <TableCell message={elem.statusName}           textColor={elem.statusColor} />
                        <TableCell message={elem.position}             />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="VIEW"   message="RESERVE_TYPES_VIEW_TITLE"   navigate />
                    <TableAction action="EDIT"   message="RESERVE_TYPES_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="RESERVE_TYPES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <ReserveTypeEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="RESERVE_TYPES_DELETE_TITLE"
            message="RESERVE_TYPES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default ReserveTypeList;
